$( function() {
  $('.bypassBlocksButton > a').on('focusin',  (el) => {
    $('.bypassBlocksButton').addClass('visible');
  });
  $('.bypassBlocksButton > a').on('focusout',  (el) => {
    $('.bypassBlocksButton').removeClass('visible');
  });
});
